import request from '../network';

export interface BreedListParams {
  breedName?: string;
  isShow?: number | string;
  petType?: string | number;
  pageNum?: number;
  pageSize?: number;
}

export const getPetBreedListApi = (data: BreedListParams) => {
  return request({
    url: '/member/royalcanin/admin/petBreed/list',
    method: 'POST',
    data,
  });
};

export const getPetBreedDetailApi = (id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/petBreed/${id}`,
    method: 'GET',
  });
};

export const updatePetBreedApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petBreed',
    method: 'PUT',
    data,
  });
};

export const createPetBreedApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petBreed',
    method: 'POST',
    data,
  });
};

export const deletePetBreedApi = (id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/petBreed/${id}`,
    method: 'DELETE',
  });
};
